import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card shadow my-3" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-hover align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "thead-loupey" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Month"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Year"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Last 4")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"m-3\"><nav aria-label=\"\"><div class=\"pagination pagination-sm justify-content-end\"><div class=\"page-item\"><a class=\"page-link\" href=\"#\">Previous</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">1</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">Next</a></div></div></nav></div>", 1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-end gap-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm btn-primary",
    "data-bs-toggle": "modal",
    "data-bs-target": "#exampleModal"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-credit-card me-2" }),
    /*#__PURE__*/_createTextVNode("Add Card ")
  ])
], -1)
const _hoisted_8 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_9 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_10 = { class: "modal-content" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\"><i class=\"fab fa-cc-stripe me-2\"></i><h5 class=\"modal-title\" id=\"exampleModalLabel\">Card Details</h5><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div><div class=\"modal-body\"><form><div class=\"row\"><div id=\"card-element\"></div></div></form></div>", 2)
const _hoisted_13 = { class: "modal-footer" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "me-auto fw-lighter fs-6" }, "Powered by Stripe©", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Cancel", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_table_row = _resolveComponent("table-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_loading, {
        active: !_ctx.isLoaded,
        isErrored: _ctx.isErrored,
        "is-full-page": false,
        onRetryRequested: _ctx.fetchData,
        errorMessage: _ctx.errorMessage
      }, null, 8, ["active", "isErrored", "onRetryRequested", "errorMessage"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
              return (_openBlock(), _createBlock(_component_table_row, {
                key: card.id,
                brand: card.brand,
                expiryMonth: card.expiryMonth,
                expiryYear: card.expiryYear,
                last4Numbers: card.last4Numbers
              }, null, 8, ["brand", "expiryMonth", "expiryYear", "last4Numbers"]))
            }), 128))
          ])
        ])
      ]),
      _hoisted_6
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#filter-bar-content" }, [
      _hoisted_7
    ])),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createCard && _ctx.createCard(...args)))
            }, "Add")
          ])
        ])
      ])
    ])
  ]))
}